<template>
  <div>
    <div class="market-box">
      <div class="all-box">
        <div class="left-box">
          <div
            class="left-item-box"
            :class="{ sel: currType === 'overview' }"
            @click="typeChange('overview')"
          >
            <img
              class="icon-de"
              v-if="currType === 'overview'"
              src="@/assets/img/images/icon/wallet-icon-all-s.png"
              alt=""
            />
            <img
              class="icon-de"
              v-else
              src="@/assets/img/images/icon/wallet-icon-all.png"
              alt=""
            />
            <p>{{ $t("asset.overview") }}</p>
          </div>
          <div
            class="left-item-box"
            :class="{ sel: currType === 'rwa' }"
            @click="typeChange('rwa')"
          >
            <img
              class="icon-de"
              v-if="currType === 'rwa'"
              src="@/assets/img/images/icon/wallet-icon1-s.png"
              alt=""
            />
            <img
              class="icon-de"
              v-else
              src="@/assets/img/images/icon/wallet-icon1.png"
              alt=""
            />
            <p>{{ $t("asset.rwa_token") }}</p>
          </div>
          <div
            class="left-item-box"
            :class="{ sel: currType === 'fund' }"
            @click="typeChange('fund')"
          >
            <img
              class="icon-de"
              v-if="currType === 'fund'"
              src="@/assets/img/images/icon/wallet-icon2-s.png"
              alt=""
            />
            <img
              class="icon-de"
              v-else
              src="@/assets/img/images/icon/wallet-icon2.png"
              alt=""
            />
            <p>{{ $t("asset.fund") }}</p>
          </div>
        </div>
        <div class="right-box" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0.7)">
          
          <div class="total-asset-card">
            <div class="asset-left">
              <div class="asset-header">
                <span class="asset-label">{{
                  $t("asset.estimated_total_assets")
                }}</span>
              </div>
              <div class="asset-amount">
                <span class="amount-value">{{ overviewData.totalAssets }}</span>
                <div
                  class="currency-selector"
                  @click.stop="toggleCurrencyPicker"
                >
                  <span class="amount-currency"> {{ legalCurrency }}</span>
                  <i class="el-icon-caret-bottom" />
                  <div class="currency-dropdown" v-if="showCurrencyPicker">
                    <div
                      class="currency-option"
                      :class="{ active: legalCurrency === 'HKD' }"
                      @click.stop="selectCurrency('HKD')"
                    >
                      <span class="currency-text">HKD</span>
                    </div>
                    <div
                      class="currency-option"
                      :class="{ active: legalCurrency === 'USD' }"
                      @click.stop="selectCurrency('USD')"
                    >
                      <span class="currency-text">USD</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="asset-right">
              <div class="profit-info">
                <!-- <span class="profit-label mr12">{{
                  $t("asset.today_profit_loss")
                }}</span>
                <span
                  :class="[
                    'profit-value',
                    overviewData.profit >= 0 ? 'positive' : 'negative',
                  ]"
                >
                  ${{ overviewData.profit >= 0 ? "+" : ""
                  }}{{ overviewData.profit }}
                  <span class="profit-rate"
                    >({{ overviewData.profitRate }})</span
                  >
                </span> -->
              </div>
              <div class="action-buttons">
                <div class="action-btn primary" @click="goRecharge">
                  <span class="btn-text">{{ $t("asset.recharge") }}</span>
                </div>
                <div class="action-btn secondary" @click="goWithdraw">
                  <span class="btn-text">{{ $t("asset.withdraw") }}</span>
                </div>
                <div class="action-btn secondary" @click="goRecords">
                  <span class="btn-text">{{ $t("asset.records") }}</span>
                </div>
              </div>
            </div>
          </div>

          <OverviewSection
            v-if="currType === 'overview'"
            :overview-data="overviewData"
            :legal-currency="legalCurrency"
            @change-tab="typeChange"
          />

          <RWASection
            v-else-if="currType === 'rwa'"
            :assets="rwaAssets"
            @select-asset="showActionMenu"
          />

          <FundSection
            v-else-if="currType === 'fund'"
            :assets="fundAssets"
            @select-asset="showActionMenu"
          />

          
          <!-- HKD兑换卡片 - 仅在资金Tab显示，每个币种一张卡片 -->
          <template v-if="currType === 'fund'">
            <div
              class="exchange-card"
              v-for="(rate, index) in exchangeRates"
              :key="index"
            >
              <div class="exchange-content">
                <p class="exchange-title">
                  {{ $t("asset.exchange_hkd_to_ht", { base: rate.base, coin: rate.coin }) }}
                </p>
                <div class="exchange-rate">
                  <span class="exchange-rate-text">1 {{ rate.base }} = {{ rate.rate }} {{ rate.coin }}</span>
                </div>
                <div class="exchange-footer">
                  <span class="exchange-record" @click="goExchangeRecord(rate)">{{ $t("asset.exchange_record", { coin: rate.coin }) }}</span>
                  <div class="exchange-btn" @click="goExchangePage(rate)">
                    <span class="exchange-btn-text">{{ $t("asset.go_now") }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <VFooter />
    <QuestionPopup />
    <ChargingDialog v-if="currentAsset" ref="chargingDialogRef" />
    <ChargingHKDDialog v-if="currentAsset" ref="chargingHKDDialogRef" />
    <WithdrawDialog v-if="currentAsset" ref="withdrawDialogRef" />
    <MarketLogDialog ref="marketLogDialogRef" />
    <ExchangeRecordDialog ref="exchangeRecordDialogRef" />
    <ExchangeHKDDialog ref="exchangeHKDDialogRef" @success="onExchangeSuccess" />
    <AssetDetailDialog
      :asset="currentAsset"
      :visible="showDetailDialog"
      @update:visible="showDetailDialog = $event"
      @recharge="handleDetailRecharge"
      @withdraw="handleDetailWithdraw"
      @records="handleDetailRecords"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index";
import ChargingDialog from "./components/ChargingDialog";
import ChargingHKDDialog from "./components/ChargingHKDDialog";
import WithdrawDialog from "./components/WithdrawDialog";
import MarketLogDialog from "./components/MarketLogDialog";
import AssetDetailDialog from "./components/AssetDetailDialog";
import ExchangeRecordDialog from "./components/ExchangeRecordDialog";
import ExchangeHKDDialog from "./components/ExchangeHKDDialog";
import OverviewSection from "./components/OverviewSection";
import RWASection from "./components/RWASection";
import FundSection from "./components/FundSection";
export default {
  components: {
    VFooter,
    QuestionPopup,
    ChargingDialog,
    ChargingHKDDialog,
    WithdrawDialog,
    MarketLogDialog,
    AssetDetailDialog,
    ExchangeRecordDialog,
    ExchangeHKDDialog,
    OverviewSection,
    RWASection,
    FundSection,
  },
  data() {
    return {
      currType: "overview",
      loading: false,
      userAssets: {},
      tableData: [],
      currentAsset: {},
      legalCurrency: "HKD",
      showCurrencyPicker: false,
      showDetailDialog: false,
      exchangeRates: [],
      overviewData: {
        totalAssets: 0,
        profit: 0,
        profitRate: "+0.00%",
        rwaTokens: 0,
        funds: 0,
      },
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
    rwaAssets() {
      return this.tableData.filter(
        (item) => item.assetType !== "USDT" && item.assetType !== "HKD",
      );
    },
    fundAssets() {
      return this.tableData.filter(
        (item) => item.assetType === "USDT" || item.assetType === "HKD",
      );
    },
  },
  created() {
    this.loadAssetData();
    this.getExchangeRates();
  },
  methods: {
    typeChange(val) {
      if (this.currType === val) return;
      this.loading = true;
      this.currType = val;
      this.$nextTick(() => {
        this.loadAssetData();
        if (val === "fund") {
          this.getExchangeRates();
        }
      });
    },
    toggleCurrencyPicker() {
      this.showCurrencyPicker = !this.showCurrencyPicker;
    },
    selectCurrency(currency) {
      if (this.legalCurrency !== currency) {
        this.legalCurrency = currency;
        this.loadAssetData();
      }
      this.showCurrencyPicker = false;
      this.$forceUpdate();
    },
    async loadAssetData() {
      this.loading = true;
      try {
        const res = await this.$axios.post("/userAssets/queryAssetList", {
          accountType: "spot",
          legalCurrency: this.legalCurrency,
        });
        if (
          res.data.code === this.errorCode.ok &&
          res.data.data &&
          res.data.data.userAssetRsps
        ) {
          this.userAssets = res.data.data;
          this.tableData = res.data.data.userAssetRsps;

          let totalAssets = 0;
          let rwaTokens = 0;
          let funds = 0;

          this.tableData.forEach((item) => {
            const assetCurrency = parseFloat(item.assetCurrency) || 0;
            totalAssets += assetCurrency;

            if (item.assetType === "USDT" || item.assetType === "HKD") {
              funds += assetCurrency;
            } else {
              rwaTokens += assetCurrency;
            }
          });

          let displayTotal = totalAssets;
          if (this.currType === "rwa") {
            displayTotal = rwaTokens;
          } else if (this.currType === "fund") {
            displayTotal = funds;
          }

          this.overviewData = {
            totalAssets: displayTotal.toFixed(2) || 0,
            profit: 0,
            profitRate: "+0.00%",
            rwaTokens: rwaTokens.toFixed(2) || 0,
            funds: funds.toFixed(2) || 0,
          };
        }
      } catch (error) {
        console.error("Failed to fetch asset data:", error);
      } finally {
        this.loading = false;
      }
    },
    showActionMenu(data) {
      this.currentAsset = data;
      this.showDetailDialog = true;
    },
    handleDetailRecharge(asset) {
      this.currentAsset = asset;
      if (asset.assetType === "HKD") {
        this.addHKDCoin();
      } else {
        this.addCoins();
      }
    },
    handleDetailWithdraw(asset) {
      this.currentAsset = asset;
      this.withdrawCoins();
    },
    handleDetailRecords(asset) {
      this.currentAsset = asset;
      this.$refs.marketLogDialogRef.initDialog(asset.assetType);
    },
    toMallDetail() {
      this.$axios
        .post("/cms/getDetail", {
          cateCode: this.currentAsset.assetType,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok && res.data.data) {
            this.$router.push({
              path: "/mall/oldDetail",
              query: { cateCode: this.currentAsset.assetType },
            });
          } else {
            this.$message.warning(this.$t("asset.no_mall_detail"));
          }
        });
    },
    addCoins() {
      if (this.currentAsset.canRecharge === -1) {
        this.$message.warning(this.$t("asset.can_not_recharge"));
        return false;
      }
      this.$refs.chargingDialogRef.init(this.currentAsset);
    },
    addHKDCoin() {
      this.$refs.chargingHKDDialogRef.init(this.currentAsset);
    },
    withdrawCoins() {
      if (this.currentAsset.canWithdraw === -1) {
        this.$message.warning(this.$t("asset.can_not_withdraw"));
        return false;
      }
      if (!this.judgeValidateNum()) {
        return false;
      }
      if (this.user.statusKycLevel !== 1) {
        this.$message.warning(this.$t("tipsVal.userAuthenticate"));
        return false;
      }
      if (this.user.tranPassword === -1) {
        this.$confirm(
          this.$t("partner.need_set_password"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("partner.set_now"),
            cancelButtonText: this.$t("partner.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({ path: "/user" });
          })
          .catch(() => {});
      } else {
        this.$refs.withdrawDialogRef.init(this.currentAsset);
      }
    },
    judgeValidateNum() {
      let sum = 0;
      if (this.user.phoneSecurity === 1) sum++;
      if (this.user.emailSecurity === 1) sum++;
      if (this.user.googleSecurity === 1) sum++;
      if (sum >= 2) {
        return true;
      } else {
        this.$message.warning(this.$t("tipsVal.validate_warning"));
        return false;
      }
    },
    goRecharge() {
      this.currentAsset = { assetType: "USDT" };
      this.$refs.chargingDialogRef.init({ assetType: "USDT" });
    },
    goWithdraw() {
      this.currentAsset = { assetType: "USDT" };
      this.$refs.withdrawDialogRef.init({ assetType: "USDT" });
    },
    goRecords() {
      this.$refs.marketLogDialogRef.initDialog();
    },
    goExchangePage(rate) {
      this.$refs.exchangeHKDDialogRef.initDialog(rate);
    },
    onExchangeSuccess() {
      this.loadAssetData();
      this.getExchangeRates();
    },
    goExchangeRecord(rate) {
      const coin = rate && rate.coin ? rate.coin : "";
      this.$refs.exchangeRecordDialogRef.initDialog(coin);
    },
    async getExchangeRates() {
      try {
        const res = await this.$axios.post(
          "/userAssets/depositHKDExchangeRate",
          {},
        );
        if (
          res.data.code === this.errorCode.ok &&
          Array.isArray(res.data.data)
        ) {
          this.exchangeRates = res.data.data;
        }
      } catch (e) {
        console.error("获取兑换汇率失败", e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.market-box {
  position: relative;
  background: #f5f6f7;
  padding: 60px 260px 120px 260px;
  .all-box {
    gap: 28px;
    display: flex;
    .left-box {
      padding: 40px;
      width: 320px;
      gap: 16px;
      height: fit-content;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      border-radius: 16px;
      .left-item-box {
        gap: 20px;
        display: flex;
        cursor: pointer;
        padding: 20px 24px;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
        border-radius: 12px;
        transition: all 0.3s;
      }
      .sel {
        font-weight: 600;
        font-size: 18px;
        color: #4063ff;
        background: #e1eaff;
      }
    }
    .right-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }
}

.total-asset-card {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 32px 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .asset-left {
    .asset-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .asset-label {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 22px;
        color: #1f2329;
        margin-right: 8px;
      }
    }

    .asset-amount {
      display: flex;
      align-items: baseline;
      position: relative;

      .amount-value {
        font-size: 40px;
        font-weight: 700;
        color: #1f2329;
      }

      .currency-selector {
        display: flex;
        align-items: center;
        margin-left: 8px;
        cursor: pointer;
        position: relative;

        .amount-currency {
          font-size: 16px;
          color: #1f2329;
        }
        i {
          font-size: 16px;
        }
      }

      .currency-dropdown {
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        background-color: #ffffff;
        border-radius: 12px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        z-index: 100;
        min-width: 100px;

        .currency-option {
          padding: 12px 20px;
          text-align: center;

          &:first-child {
            border-radius: 12px 12px 0 0;
          }

          &:last-child {
            border-radius: 0 0 12px 12px;
          }

          &.active {
            background-color: #f0f5ff;

            .currency-text {
              color: #4063ff;
              font-weight: 600;
            }
          }

          .currency-text {
            font-size: 16px;
            color: #333333;
          }
        }
      }
    }
  }

  .asset-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 20px;

    .profit-info {
      display: flex;
      align-items: flex-end;

      .profit-label {
        font-size: 14px;
        color: #999999;
        margin-bottom: 4px;
      }

      .profit-value {
        font-size: 18px;
        font-weight: 600;

        &.positive {
          color: #52c41a;
        }

        &.negative {
          color: #ff4d4f;
        }

        .profit-rate {
          font-size: 14px;
          opacity: 0.8;
          margin-left: 4px;
        }
      }
    }

    .action-buttons {
      display: flex;
      gap: 12px;

      .action-btn {
        padding: 12px 28px;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;

        &.primary {
          background-color: #4063ff;

          .btn-text {
            color: #ffffff;
            font-weight: 600;
          }
        }

        &.secondary {
          background-color: #f5f5f5;

          .btn-text {
            color: #666666;
          }
        }

        .btn-text {
          font-size: 14px;
        }
      }
    }
  }
}
.icon-de {
  width: 44px;
  height: 44px;
}

.exchange-card {
  background: linear-gradient(135deg, #f8f9ff 0%, #eef1ff 100%);
  border-radius: 16px;
  padding: 28px 32px;

  .exchange-content {
    display: flex;
    flex-direction: column;
  }

  .exchange-title {
    font-size: 20px;
    font-weight: 600;
    color: #1f2329;
    margin: 0 0 12px 0;
  }

  .exchange-rate {
    margin-bottom: 24px;

    .exchange-rate-text {
      font-size: 16px;
      color: #4063ff;
      font-weight: 600;
    }
  }

  .exchange-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .exchange-record {
    font-size: 14px;
    color: #999999;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #4063ff;
    }
  }

  .exchange-btn {
    background-color: #4063ff;
    border-radius: 10px;
    padding: 10px 28px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #3352e0;
      box-shadow: 0 4px 12px rgba(64, 99, 255, 0.3);
    }

    .exchange-btn-text {
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>
